module.exports = __webpack_public_path__ + "img/usb-fill.1b376bd0.svg";